"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @enum NChangedProductState
 */


var NChangedProductState;

(function (NChangedProductState) {
  NChangedProductState["Inserted"] = "INSERTED";
  NChangedProductState["Deleted"] = "DELETED";
})(NChangedProductState = exports.NChangedProductState || (exports.NChangedProductState = {}));
/**
 * @author Tomas Leity
 */


var NChangedProduct =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NChangedProduct, _NotificationDoc_1$No);

  /**
   * @param productId
   * @param productName
   * @param promoVolume
   * @param systemVolume
   * @param state
   */
  function NChangedProduct(productId, productName, promoVolume, systemVolume, state) {
    var _this;

    _classCallCheck(this, NChangedProduct);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedProduct).call(this));
    _this.productId = productId;
    _this.productName = productName;
    _this.promoVolume = promoVolume;
    _this.systemVolume = systemVolume;
    _this.state = state;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NChangedProduct, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NChangedProduct(mat.productId, mat.productName, mat.promoVolume, mat.systemVolume, mat.state);
    }
  }]);

  return NChangedProduct;
}(NotificationDoc_1.NotificationDoc);

exports.NChangedProduct = NChangedProduct;

NChangedProduct.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NChangedProduct.name);
  return {
    productId: builder.id('productId'),
    productName: builder.str('productName'),
    promoVolume: builder.bigNum('promoVolume'),
    systemVolume: builder.bigNum('promoVolume'),
    state: builder.senum('lockType', NChangedProductState, '')
  };
}();